import React from 'react'

export default function Services() {
  return (
    <>
        <section class="service_sec1 p-0">
        <video src={require('../../assets/video/Adret intro video.mp4')} autoPlay muted loop />
            <div class="container">
                <div class="row">
                    <div class="col-lg-7 gaps">
                        <div class="heading">
                            <h2>Website, Mobile App And Digital Marketing Services</h2>
                           <p>
                            Adret Software is the one-stop where you can find excellent services to start your business with a bang digitally and get it ranked on the top in the search results. Apart from providing top-notch websites, mobile apps design and development, we can act as a game-changer for your business success. 
                           </p>
                            <div class="btn_sec">
                                <a href="contact.html" class="btn1 btn_gap">Quick Enquiry</a>
                                <a href="tel:+91 9432205976" class="btn2">Call Us : +91 9432205976</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="featured_service_sec bg_color1 " id="service_sec">
            <div class="container">
           
                <div class="row g-4">
               
                    <div class="col-lg-12">
                        <div class="sevice_card aos-init" data-aos="fade-up" data-aos-duration="3000">
                            <div class="row g-0 align-items-center">
                                <div class="col-sm-5  col-12">
                                    <div class="content_img">
                                        <img src="assets/image/service-webdesign-img1.png" alt="" class="img-fluid"/>
                                    </div>
                                </div>
                                <div class="col-sm-7 col-12">
                                    <div class="content_left text-white">
                                        <h4>Website Design Services</h4>
                                        <p>
                                            Crafting captivating visual identities and messaging that resonate, strengthening brand recognition, trust, and differentiation, driving memorable and impactful audience connections.
                                        </p>
                                        <ul class="service_ul">
                                            <li><a href=""> <i class="ri-arrow-right-double-line"></i>eCommerce Website Design</a>
                                            </li>
                                            <li> <a href=""> <i class="ri-arrow-right-double-line"></i>Web Application Development</a></li>
                                            <li><a href=""> <i class="ri-arrow-right-double-line"></i>CMS Development</a></li>
                                            <li><a href=""> <i class="ri-arrow-right-double-line"></i>Small Business Website</a></li>
                                            <li> <a href=""> <i class="ri-arrow-right-double-line"></i>Corporate Website</a>
                                            </li>
                                           
                                        </ul>

                                        <div class="btn_sec mt-4">
                                            <a href="website-design.html" class="btn1">Know In Detail</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="sevice_card aos-init" data-aos="fade-up" data-aos-duration="3000">
                            <div class="row g-0 align-items-center">
                               
                                <div class="col-sm-7 col-12 order-2 order-lg-1">
                                    <div class="content_left text-white">
                                        <h4>Mobile App Development</h4>
                                        <p>
                                            Crafting captivating visual identities and messaging that resonate, strengthening brand recognition, trust, and differentiation, driving memorable and impactful audience connections.
                                        </p>
                                        <ul class="service_ul">
                                            <li><a href=""> <i class="ri-arrow-right-double-line"></i>Android App development</a>
                                            </li>
                                            <li> <a href=""> <i class="ri-arrow-right-double-line"></i>iOS App Develoment</a></li>
                                            <li><a href=""> <i class="ri-arrow-right-double-line"></i>Hybrid App development</a></li>

                        
                                        </ul>
                                        <div class="btn_sec mt-4">
                                            <a href="mobile-app-development.html" class="btn1">Know In Detail</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-5  col-12 order-1 order-lg-2">
                                    <div class="content_img">
                                        <img src="assets/image/mobile-app-service-img.png" alt="" class="img-fluid"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="sevice_card aos-init" data-aos="fade-up" data-aos-duration="3000">
                            <div class="row g-0 align-items-center">
                                <div class="col-sm-5  col-12">
                                    <div class="content_img">
                                        <img src="assets/image/digital-marketing-service-img1.jpg" alt="" class="img-fluid"/>
                                    </div>
                                </div>
                                <div class="col-sm-7 col-12">
                                    <div class="content_left text-white">
                                        <h4>Digital Marketing Services</h4>
                                        <p>
                                            Crafting captivating visual identities and messaging that resonate, strengthening brand recognition, trust, and differentiation, driving memorable and impactful audience connections.
                                        </p>
                                        <ul class="service_ul">
                                            <li><a href=""> <i class="ri-arrow-right-double-line"></i>SEO Services</a>
                                            </li>
                                            <li> <a href=""> <i class="ri-arrow-right-double-line"></i>Social Media Marketing</a></li>
                                            <li><a href=""> <i class="ri-arrow-right-double-line"></i>PPC Management</a></li>
                                            <li><a href=""> <i class="ri-arrow-right-double-line"></i>Local SEO Services</a></li>
                                            <li> <a href=""> <i class="ri-arrow-right-double-line"></i>Content Marketing Services</a>
                                            </li>
                                           
                                        </ul>

                                        <div class="btn_sec mt-4">
                                            <a href="website-design.html" class="btn1">Know In Detail</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="sevice_card aos-init" data-aos="fade-up" data-aos-duration="3000">
                            <div class="row g-0 align-items-center">
                               
                                <div class="col-sm-7 col-12 order-2 order-lg-1">
                                    <div class="content_left text-white">
                                        <h4>eCommerce Website Design</h4>
                                        <p>
                                            Crafting captivating visual identities and messaging that resonate, strengthening brand recognition, trust, and differentiation, driving memorable and impactful audience connections.
                                        </p>
                                        <ul class="service_ul">
                                            <li><a href=""> <i class="ri-arrow-right-double-line"></i>Magento Development</a>
                                            </li>
                                            <li> <a href=""> <i class="ri-arrow-right-double-line"></i>Shopify Development</a></li>
                                            <li><a href=""> <i class="ri-arrow-right-double-line"></i>BigCommerce</a></li>
                                            <li><a href=""> <i class="ri-arrow-right-double-line"></i>WooCommerce Development</a></li>
                                            <li> <a href=""> <i class="ri-arrow-right-double-line"></i>OpenCart Development</a>
                                            </li>
                                           
                                        </ul>
                                        
                                        <div class="btn_sec mt-4">
                                            <a href="website-design.html" class="btn1">Know In Detail</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-5  col-12 order-1 order-lg-2">
                                    <div class="content_img">
                                        <img src="assets/image/ecommerce-service-img.jpg" alt="" class="img-fluid"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="sevice_card aos-init" data-aos="fade-up" data-aos-duration="3000">
                            <div class="row g-0 align-items-center">
                                <div class="col-sm-5  col-12">
                                    <div class="content_img">
                                        <img src="assets/image/brand-wed-img.jpg" alt="" class="img-fluid"/>
                                    </div>
                                </div>
                                <div class="col-sm-7 col-12">
                                    <div class="content_left text-white">
                                        <h4>Brand Identity Design</h4>
                                        <p>
                                            Crafting captivating visual identities and messaging that resonate, strengthening brand recognition, trust, and differentiation, driving memorable and impactful audience connections.
                                        </p>
                                        <ul class="service_ul">
                                            <li><a href=""> <i class="ri-arrow-right-double-line"></i>Logo Design Services</a>
                                            </li>
                                            <li> <a href=""> <i class="ri-arrow-right-double-line"></i>Brochure Design Services</a></li>
                                            <li><a href=""> <i class="ri-arrow-right-double-line"></i>Corporate Identity Design</a></li>
                                            <li><a href=""> <i class="ri-arrow-right-double-line"></i>Explainer Videos</a></li>
                                            
                                           
                                        </ul>

                                        <div class="btn_sec mt-4">
                                            <a href="website-design.html" class="btn1">Know In Detail</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="sevice_card aos-init" data-aos="fade-up" data-aos-duration="3000">
                            <div class="row g-0 align-items-center">
                               
                                <div class="col-sm-7 col-12 order-2 order-lg-1">
                                    <div class="content_left text-white">
                                        <h4>Hire Web & Mobile Developers</h4>
                                        <p>
                                            Crafting captivating visual identities and messaging that resonate, strengthening brand recognition, trust, and differentiation, driving memorable and impactful audience connections.
                                        </p>
                                        <ul class="service_ul">
                                            <li><a href=""> <i class="ri-arrow-right-double-line"></i>Hire Angular Developer</a>
                                            </li>
                                            <li> <a href=""> <i class="ri-arrow-right-double-line"></i>Hire Node.js Developer</a></li>
                                            <li><a href=""> <i class="ri-arrow-right-double-line"></i>Hire Laravel Developer</a></li>
                                            <li><a href=""> <i class="ri-arrow-right-double-line"></i>Hire PHP Developer</a></li>
                                            <li> <a href=""> <i class="ri-arrow-right-double-line"></i>Hire Wordpress Developer</a>
                                            </li>
                                            <li> <a href=""> <i class="ri-arrow-right-double-line"></i>Hire Android App Developer</a>
                                            </li>
                                            <li> <a href=""> <i class="ri-arrow-right-double-line"></i>Hire IOS Developer</a>
                                            </li>
                                            <li> <a href=""> <i class="ri-arrow-right-double-line"></i>Hire React Native Developer</a>
                                            </li>
                                        </ul>
                                        
                                        <div class="btn_sec mt-4">
                                            <a href="website-design.html" class="btn1">Know In Detail</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-5  col-12 order-1 order-lg-2">
                                    <div class="content_img">
                                        <img src="assets/image/web-heir-img.jpg" alt="" class="img-fluid"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>

        <section class="logo_design_project p-0" id="android_app">
            <div class="row g-0 ">
                <div class="col-lg-5">
                    <div class="content_img aos-init aos-animate" data-aos="fade-right" data-aos-duration="2000">
                        <img src="assets/image/call-suprot-img.png" class="img-fluid" alt=""/>
                    </div>
                </div>
                <div class="col-lg-7 text-center">
                    <div class="heading aos-init aos-animate" data-aos="fade-left" data-aos-duration="2000">
                        <h3> Support For 24/7</h3>
                        <p>
                            What can we do for you?
We would be happy to discuss the project with you in person
                        </p>
                            <div class="btn_sec">
                                <a href="" class="btn2">Request a quote</a>
                            </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="logo_design_sec">
            <div class="container">
                <div class="heading aos-init aos-animate" data-aos="fade-down" data-aos-duration="2000">
                    <h2>Why Choose Adret Software?</h2>
                    <p>
                        Entrust your Android app development needs to our experts. We assure you of:
                    </p>
                </div>
                <div class="row g-4 align-items-center">
                    <div class="col-lg-8">
                        <div class="row">

                            <div class="col-lg-6">
                                <div class="content_why aos-init aos-animate" data-aos="fade-up" data-aos-duration="2000">
                                    <div class="left_icon">
                                        <img src="assets/image/logo-design-icon1.png" alt="" class="img-fluid"/>
                                    </div>
                                    <div class="content">
                                        <h5>Best Technologies</h5>
                                        <p>
                                            Our digital craftsmen are super developers who code to develop functional, manageable and scalable products.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="content_why aos-init aos-animate" data-aos="fade-up" data-aos-duration="2000">
                                    <div class="left_icon">
                                        <img src="assets/image/logo-design-icon2.png" alt="" class="img-fluid"/>
                                    </div>
                                    <div class="content">
                                        <h5>Reasonable Costs</h5>
                                        <p>
                                            We ensure you quality services at the most reasonable prices.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="content_why aos-init" data-aos="fade-up" data-aos-duration="2000">
                                    <div class="left_icon">
                                        <img src="assets/image/logo-design-icon3.png" alt="" class="img-fluid"/>
                                    </div>
                                    <div class="content">
                                        <h5>Skilled Team</h5>
                                        <p>
                                            We have some really knowledgeable and skilled developers in our midst.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="content_why aos-init" data-aos="fade-up" data-aos-duration="2000">
                                    <div class="left_icon">
                                        <img src="assets/image/logo-design-icon4.png" alt="" class="img-fluid"/>
                                    </div>
                                    <div class="content">
                                        <h5>Extensive Experience</h5>
                                        <p>
                                            Our team has completed thousands of projects in 25+ countries worldwide.
                                            </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                      
                    </div>
                    <div class="col-lg-4">
                        <img src="assets/image/android-app-development-img1.jpg" class="img-fluid rounded aos-init aos-animate" alt="" data-aos="zoom-out" data-aos-duration="2000"/>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}
